import { useState } from 'react';
import { Box, TextField, Typography, Button, Link } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { useNavigate, Link as RouterLink } from 'react-router-dom';

function PasswordGate() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const { authenticate } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e?: React.FormEvent) => {
    if (e) e.preventDefault();
    const isValid = await authenticate(password);
    if (!isValid) {
      setError(true);
    } else {
      navigate('/rsvp');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
        px: 2
      }}
    >
      <Box 
        component="img"
        src="/moose_logo.png"
        alt="Moose Logo"
        sx={{
          width: '300px',
          height: '300px',
          mb: 4
        }}
      />
      
      {/* Hidden link for SEO - visible to search engines but not to users */}
      <Link 
        component={RouterLink} 
        to="/seo" 
        sx={{ 
          position: 'absolute', 
          left: '-9999px',
          height: '1px',
          width: '1px',
          overflow: 'hidden',
          /* This ensures the link is not visible to users but is to search engines */
        }}
        aria-label="Wedding information for Sam Musso and Alexa Ballenger"
      >
        Sam Musso and Alexa Ballenger Wedding Information
      </Link>
      
      <Box 
        component="form" 
        onSubmit={handleSubmit}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          maxWidth: '400px'
        }}
      >
        <TextField
          fullWidth
          type="password"
          placeholder="Password"
          variant="outlined"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            setError(false);
          }}
          error={error}
          sx={{
            '& .MuiOutlinedInput-root': {
              bgcolor: 'white',
              borderRadius: '4px',
            }
          }}
        />
        
        {/* Add submit button that only shows on mobile when password has content */}
        {password.length > 0 && (
          <Button
            variant="contained"
            size="large"
            onClick={() => handleSubmit()}
            sx={{
              mt: 3,
              display: { xs: 'block', sm: 'none' }, // Only show on mobile
              width: '100%',
              py: 1.5,
              borderRadius: 25,
              fontFamily: '"Open Sans", sans-serif',
              backgroundColor: 'rgba(175, 99, 42, 1)',
              color: '#fff',
              '&:hover': {
                backgroundColor: 'rgba(187, 138, 101, 1)',
              },
            }}
          >
            Submit
          </Button>
        )}
        
        <Typography 
          variant="caption" 
          color="text.secondary"
          sx={{ 
            mt: 1,
            fontSize: '12px',
            color: '#666'
          }}
        >
          Please enter the password listed on the wedding invite
        </Typography>
      </Box>
    </Box>
  );
}

export default PasswordGate;
